import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/** On client-side navigation: scroll to top and move focus to <main> so screen-reader and keyboard users land at the new page. */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (first.current) { first.current = false; return; }
    document.getElementById('main')?.focus({ preventScroll: true });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
